import { Checkbox, FormControl, FormControlLabel, FormLabel, Radio, RadioGroup, Switch } from "@material-ui/core"
import CustomInput from "components/CustomInput"
import DropdownFilter from "components/DropdownFilter"
import LotsDropdown from "components/SharedDropdowns/LotsDropDown"
import ActivityTypesField from "features/activity/ActivityTypesField"
import { TenantNameResolver } from "features/saasManagement/TenantNameResolver/TenantNameResolver"
import { IconDollar } from "icons"
import { VendorField } from "./VendorField"

export const activityPriceFields = {
    ACTIVITY: 1,
    VENDOR: 2,
    LOT_OPTIONS: 3,
    LOT_TOGGLE: 4,
    LOT: 5,
    VEHICLE_TYPES: 6,
    NOT_SUPPORTED: 7,
    PRICE: 8,
    USE_INVENTORY: 9,
    CLIENT: 10
}

export const activityPriceConfig = {
    [activityPriceFields.ACTIVITY]: {
        name: 'Activity',
        component: (value, onChange) => <ActivityTypesField 
            value={value} 
            onChange={onChange}
        />
    },
    [activityPriceFields.CLIENT]: {
        name: 'Client',
        component: (value, values, onChange, required, label) => <DropdownFilter
            required={required}
            title={label}
            value={value}
            onSelect={val => onChange(val)}
            values={values}
            multiple={false}
            showEmpty
        />
    },
    [activityPriceFields.VENDOR]: {
        name: 'Vendor',
        component: (value, values, onChange, required, label, multiple) => <VendorField
            value={value}
            onChange={val => onChange(val)}
            label={label}
            required={required}
            multiple={multiple}
        />
    },
    [activityPriceFields.LOT_OPTIONS]: {
        name: '',
        component: (value, values, onChange, required, label) => <FormControl>
            <FormLabel id="lot-radio-group">{label}</FormLabel>
            <RadioGroup
                value={value}
                onChange={onChange}
                aria-labelledby="lot-radio-group"
                name="lot-radio-group"
                row
            >
                <FormControlLabel value={toggleOptions.ALL_LOTS} control={<Radio />} label="All Lots" />
                <FormControlLabel value={toggleOptions.SPECIFIC_LOTS} control={<Radio />} label="Specific Lots" />
                <FormControlLabel value={toggleOptions.ALL_TENANT_LOTS} control={<Radio />} label={<TenantNameResolver startText="All" endText="Lots" />} />
            </RadioGroup>
        </FormControl>
    },
    [activityPriceFields.LOT_TOGGLE]: {
        name: <TenantNameResolver startText="Include Non" endText="Lots" />,
        component: (checked, onChange, label) => <FormControlLabel
            control={<Switch
                color="primary"
                inputProps={{ 'aria-label': 'controlled' }}
                onChange={onChange}
                checked={checked}
            />}
            label={label}
        />
    },
    [activityPriceFields.LOT]: {
        name: 'Lot',
        component: (value, values, onChange, required, label, multiple, ownedByTenant) => <LotsDropdown
            title={label}
            identifier='lot'
            values={values}
            onSelect={val => onChange(val)}
            value={value}
            showEmpty={true}
            required={required}
            ownedByTenant={ownedByTenant}
            multiple={multiple}
        />
    },
    [activityPriceFields.VEHICLE_TYPES]: {
        name: 'Vehicle Type',
        component: (value, values, onChange, required, label) => <DropdownFilter
            required={required}
            title={label}
            value={value}
            onSelect={val => onChange(val)}
            values={values}
            multiple={true}
            showEmpty={false}
        />
    },
    [activityPriceFields.NOT_SUPPORTED]: {
        name: '',
        component: (checked, onChange, label) => <FormControlLabel
            control={<Checkbox
                checked={checked}
                onChange={onChange}
            />}
            label={label}
            labelPlacement="end"
        />
    },
    [activityPriceFields.PRICE]: {
        name: 'Price',
        component: (value, values, onChange, required, label) => <CustomInput
            id="ddlActivityPrice"
            label={label}
            elementType="input"
            value={value}
            required={required}
            onChange={val => onChange(val)}
            numberOnly
            icon={<IconDollar />}
        />
    },
    [activityPriceFields.USE_INVENTORY]: {
        name: 'Use Inventory',
        component: (checked, onChange, label) => <FormControlLabel
            control={<Checkbox
                checked={checked}
                onChange={onChange}
            />}
            label={label}
            labelPlacement="end"
        />
    }
}

export const toggleOptions = {
    SPECIFIC_LOTS: 'specific-lots',
    ALL_LOTS: 'all-lots',
    ALL_TENANT_LOTS: 'all-tenant-lots'
}